<template>
  <div>
    <HeadlineContainer headline="Retention Touchpoints" :breadcrumbs="[{text: 'Retention Touchpoints'}]">
      <router-link to="/retention-touchpoints/create" class="btn btn-white">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </HeadlineContainer>

    <div class="container">
      <RetentionTouchpointList/>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import RetentionTouchpointList from '../../../components/Administration/RetentionTouchpoints/Panels/List'

export default {
  components: {HeadlineContainer, RetentionTouchpointList}
}
</script>
